import { render, staticRenderFns } from "./quotation.vue?vue&type=template&id=27288a3e&"
import script from "./quotation.vue?vue&type=script&lang=js&"
export * from "./quotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports